import { Injectable } from '@angular/core';
import {
  distinctUntilChanged,
  filter,
  fromEvent,
  map,
  Observable,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  get(key: string): any {
    const storedValue = localStorage.getItem(key);
    return !!storedValue ? JSON.parse(storedValue) : null;
  }

  set(key: string, value: unknown): void {
    localStorage.setItem(key, !!value ? JSON.stringify(value) : null);
  }

  watch(key: string): Observable<any> {
    return fromEvent(window, 'storage').pipe(
      distinctUntilChanged(
        (prev, curr) => curr['newValue'] == prev['newValue']
      ),

      filter((event: StorageEvent) => event.key === key || !!key),
      map(() => this.get(key))
    );
  }
}
